import * as yup from "yup";
import {
  getStringRequiredFieldMessage,
  validatePhoneNumber,
} from "@shared/utils/yup-extensions";

export const userProfileFormSchema = yup
  .object()
  .shape({
    name: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Name"),
    countryState: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("State"),
    country: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Country"),
    phoneNumber: yup
      .string()
      .test(
        validatePhoneNumber({
          message: "Invalid phone number",
          region: "US",
          optional: true,
        })
      )
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Phone Number"),
    officeName: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Brokerage Name"),
    website: yup
      .string()
      .trim()
      .url("Invalid URL")
      .optional()
      .nullable()
      .label("Website"),
  })
  .required();

export type UserProfileSchema = typeof userProfileFormSchema.__outputType;

export const USER_PROFILE_SCHEMA_DEFAULT_VALUES: UserProfileSchema = {
  name: "",
  countryState: "",
  country: "",
  phoneNumber: "",
  officeName: "",
  website: "",
};
